import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import withRouter from "components/Common/withRouter";
import { withTranslation } from "react-i18next";
import SidebarContent from "./SidebarContent";
import { Link } from "react-router-dom";
import { usePermissionContext } from "libs/context/PermissionContext";

import logo from "../../assets/images/logo.png";
import logoLightPng from "../../assets/images/logo.png";
import logoLightSvg from "../../assets/images/logo.png";
import logoDark from "../../assets/images/logo.png";
import smallIcon from "../../assets/images/small_icon.png";
import { Card, CardBody } from "reactstrap";

/** Avatar when user has no image or load fails (`public/no-image.png`). */
const defaultSidebarAvatarSrc = `${process.env.PUBLIC_URL || ""}/no-image.png`;

const resolveUserAvatarUrl = (user) => {
  if (!user || typeof user !== "object") return null;
  const raw = [
    user.profileImage,
    user.profilePic,
    user.userImage,
    user.photo,
    user.image,
    user.avatar,
    user.picture,
  ].find((v) => v != null && String(v).trim());

  if (!raw) return null;
  const s = String(raw).trim();
  if (/^https?:\/\//i.test(s)) return s;

  const base = String(process.env.REACT_APP_ASSETS_URL || "").replace(/\/$/, "");
  if (!base) {
    return s.startsWith("/") ? s : `/${s}`;
  }
  return `${base}/${s.replace(/^\//, "")}`;
};

const Sidebar = (props) => {
  const { permissionData } = usePermissionContext() || {};
  const leftSideBarType = useSelector((state) => state.Layout?.leftSideBarType);
  let authUser = JSON?.parse(localStorage.getItem("userData"))
  const [bodyCollapsed, setBodyCollapsed] = useState(() =>
    typeof document !== "undefined" &&
    document.body.classList.contains("vertical-collpsed")
  );

  // useEffect(() => {
  //   console.log("user-info/permissions", permissionData);
  // }, [permissionData]);

  useEffect(() => {
    const sync = () => {
      setBodyCollapsed(
        document.body.classList.contains("vertical-collpsed")
      );
    };
    sync();
    const observer = new MutationObserver(sync);
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["class"],
    });
    return () => observer.disconnect();
  }, []);

  const [sidebarAvatarFailed, setSidebarAvatarFailed] = useState(false);
  const resolvedAvatar = resolveUserAvatarUrl(authUser);

  useEffect(() => {
    setSidebarAvatarFailed(false);
  }, [resolvedAvatar]);

  const isCollapsedSidebar =
    bodyCollapsed || leftSideBarType === "condensed";

  const sidebarAvatarSrc =
    !resolvedAvatar || sidebarAvatarFailed
      ? defaultSidebarAvatarSrc
      : resolvedAvatar;

  return (
    <React.Fragment>
      <div
        className="vertical-menu fixed-sidebar verticalSidebarTop"
        // style={{
        //   position: "fixed",
        //   top: 0,
        //   left: 0,
        //   bottom: 0,
        //   width: "260px",
        //   backgroundColor: "#081647",
        //   zIndex: 1050,
        //   overflow: "hidden",
        // }}
      >
        {/* Logo Section */}
        {/* <div
          className="navbar-brand-box d-flex align-items-center justify-content-center"
          style={{
            height: "64px",
            borderBottom: "1px solid rgba(255,255,255,0.1)",
          }}
        >
          <Link to="/" className="logo logo-dark">
            <span className="logo-lg">
              <img src={logoDark} alt="logo" height="22" />
            </span>
          </Link>

          <Link to="/" className="logo logo-light d-none">
            <span className="logo-lg">
              <img src={logoLightPng} alt="logo" height="22" />
            </span>
          </Link>
        </div> */}

        <Card
          className={`sidebar-avatar${
            isCollapsedSidebar ? " sidebar-avatar--collapsed" : ""
          }`}
        >
          <CardBody
            className={`d-flex align-items-center${
              isCollapsedSidebar ? " justify-content-center" : ""
            }`}
            style={{ padding: isCollapsedSidebar ? "8px" : "10px" }}
          >
            {isCollapsedSidebar ? (
              <Link
                to="/dashboard"
                className="sidebar-collapsed-brand-icon"
                title="Home"
                aria-label="Home"
              >
                <img src={smallIcon} alt="" width="32" height="32" />
              </Link>
            ) : (
              <>
                <img
                  src={sidebarAvatarSrc}
                  alt=""
                  width={48}
                  height={48}
                  loading="lazy"
                  decoding="async"
                  onError={() => setSidebarAvatarFailed(true)}
                  style={{
                    width: "48px",
                    height: "48px",
                    borderRadius: "50%",
                    marginRight: "12px",
                    objectFit: "cover",
                    backgroundColor: "#d9d9d9",
                    flexShrink: 0,
                    display: "block",
                  }}
                />

                <div>
                  <h6 style={{ margin: 0, color: "white", fontWeight: 600 }}>
                    {authUser?.name}
                  </h6>
                  <small style={{ color: "rgba(255,255,255,0.6)" }}>
                    {authUser?.userTypeName}
                  </small>
                </div>
              </>
            )}
          </CardBody>
        </Card>

        {/* Sidebar Content */}
        <div className="sidebar-scroll-area">
          <SidebarContent />
        </div>

        {/* Optional background layer */}
        <div className="sidebar-background"></div>
      </div>
    </React.Fragment>
  );
};

Sidebar.propTypes = {
  type: PropTypes.string,
};

const mapStatetoProps = (state) => {
  return {
    layout: state.Layout,
  };
};

export default connect(mapStatetoProps, {})(
  withRouter(withTranslation()(Sidebar))
);
